const styles = () => ({
  dialogBox: {
    width: '530px',
    padding: '10px',
  },
})

export default styles
